import { useSelector, useStore } from "react-redux";
import PubSub from "pubsub-js";
import { getFormattedPrice } from "../../utils";
import { useFloating, autoUpdate } from "@floating-ui/react-dom";
import { Transition } from "react-transition-group";

import { CART_ITEM_ADDED, CART_ITEMS_ADDED } from "../../constants";
import { CartService } from "../../services/CartService";
import ProductAddedPopupContent from "../productPopups/ProductAddedPopupContent";
import MultipleProductsAddPopupContent from "../productPopups/MultipleProductsAddPopupContent";
import { getTotalPrice, getTotalQuantity } from "../../services/cartUtils";
import { cartLocalStorageService } from "../../services/CartLocalStorageService";

import "../../../styles/components/_notification.scss";

const duration = 300;

const defaultStyle = {
  transition: `opacity ${duration}ms ease-in-out`,
  opacity: 0,
};

const transitionStyles = {
  entering: { opacity: 1 },
  entered: { opacity: 1 },
  exiting: { opacity: 0 },
  exited: { opacity: 0 },
};

const HeaderCart = () => {
  const cartData = useSelector((state) => state.cart);
  const store = useStore();
  const showVAT = useSelector((state) => state.settings.showVAT);
  const [tempNewItem, setTempNewItem] = React.useState(null);
  const [multipleNewProducts, setMultipleNewProducts] = React.useState(null);
  const [showPopup, setShowPopup] = React.useState(false);
  const timerId = React.useRef(null);
  const [cartService] = React.useState(new CartService(store));

  const { x, y, reference, floating, strategy } = useFloating({
    strategy: "fixed",
    placement: "bottom-end",
    whileElementsMounted: autoUpdate,
  });

  const showNotificationPopup = () => {
    setShowPopup(true);
    if (timerId.current) {
      clearTimeout(timerId.current);
    }
    timerId.current = setTimeout(() => {
      handleClosePopup();
    }, 3000);
  };

  const onAddCartItem = (msg, item) => {
    setTempNewItem(item);
    showNotificationPopup();
  };

  const onAddCartItems = (msg, products) => {
    setMultipleNewProducts(products);
    showNotificationPopup();
  };

  const fetchCartData = async () => {
    const urlParams = new URLSearchParams(window.location.search);

    const cartId = urlParams.get("cart_id");
    if (cartId) {
      await cartService.fetchCart(cartId);
    } else {
      cartService.updateCartByTime();
    }
  };

  React.useEffect(() => {
    fetchCartData();

    if (window.location.pathname.includes("/confirmation")) {
      cartService.deleteCart();
    }

    const token = PubSub.subscribe(CART_ITEM_ADDED, onAddCartItem);
    const sub = PubSub.subscribe(CART_ITEMS_ADDED, onAddCartItems);

    return () => {
      PubSub.unsubscribe(token);
      PubSub.unsubscribe(sub);
      if (timerId.current) {
        clearTimeout(timerId.current);
      }
    };
  }, []);

  const itemsCount = getTotalQuantity(cartData);
  const totalPrice = getTotalPrice(cartData, showVAT);

  const onCartClick = () => {
    var url = $("#CART_URL").val();
    window.location.assign(url);
  };

  const goCheckout = () => {
    var url = $("#CHECKOUT_URL").val();
    window.location.assign(url);
  };

  const handleClosePopup = () => {
    setShowPopup(false);
    setTimeout(() => {
      setTempNewItem(null);
      setMultipleNewProducts(null);
    }, duration);
  };

  return (
    <div className="header-cart">
      <button ref={reference} className="btn cart-button" onClick={onCartClick}>
        <div className="cart-wrapper">
          <svg className="icon icon--cart" width="30" height="25">
            <use
              xlinkHref={`${$(
                "#STATIC_ASSETS_URL"
              ).val()}/images/sprites/symbol/sprite.svg#cart`}
            />
          </svg>
          {itemsCount ? (
            <div className="cart-badge">
              {itemsCount > 999 ? "999+" : itemsCount}
            </div>
          ) : null}
        </div>

        <span className="d-none d-sm-block">
          {getFormattedPrice(totalPrice)}
        </span>
      </button>

      <Transition in={showPopup} timeout={500} mountOnEnter unmountOnExit>
        {(state) => (
          <div
            className="notification"
            ref={floating}
            style={{
              position: strategy,
              top: y ?? 0,
              left: x ?? 0,
              ...defaultStyle,
              ...transitionStyles[state],
            }}
          >
            <div className="d-flex flex-column">
              {tempNewItem && (
                <ProductAddedPopupContent
                  product={tempNewItem}
                  showVAT={showVAT}
                />
              )}
              {multipleNewProducts && (
                <MultipleProductsAddPopupContent
                  products={multipleNewProducts}
                  showVAT={showVAT}
                />
              )}
            </div>
            <div className="mt-2 d-flex flex-space-between align-items-center">
              <button
                className="btn btn-link btn-popup-close"
                onClick={handleClosePopup}
              >
                Fjern
              </button>
              <button
                onClick={goCheckout}
                className="btn-go-checkout btn btn-primary"
              >
                Gå til kassen
              </button>
            </div>
          </div>
        )}
      </Transition>
    </div>
  );
};

export default HeaderCart;
